var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MixedKeyboard',{ref:"mixedKeyboard",on:{"onChanged":_vm.doChanged,"onBackClick":_vm.doBackClick,"onCommitClick":_vm.doCommitClick,"onClearClick":_vm.doClearClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }